// extracted by mini-css-extract-plugin
export default {"btop":"d6d8ca3a57 ce7be5757b _8ae99167cb","icon":"_4a23a1a5ae a553a7ea8f","btoppink":"_238e93e185 _179d385853"};